@if (hub.aberto()) {
  <button type="button" class="mg-suporte-hub__veu" aria-label="Fechar ajuda" (click)="fechar()"></button>
  <aside
    class="mg-suporte mg-suporte-hub"
    role="dialog"
    aria-modal="true"
    aria-labelledby="suporte-hub-titulo"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
    (keydown.escape)="fechar()">
    <div class="mg-suporte-hub__cabecalho">
      <div class="mg-suporte-painel__cabecalho">
        <h2 id="suporte-hub-titulo" class="mg-suporte-painel__titulo">Ajuda e suporte</h2>
        <button type="button" matIconButton aria-label="Fechar ajuda" (click)="fechar()">
          <mat-icon svgIcon="close" aria-hidden="true" />
        </button>
      </div>
      @if (linhaDeStatus(); as linha) {
        <p class="mg-suporte-hub__status">
          <span class="mg-suporte-hub__ponto" [ngClass]="'mg-suporte-hub__ponto--' + linha.categoria" aria-hidden="true"></span>
          @if (linha.severidade) {
            <app-support-status-chip eixo="severidade" [valor]="linha.severidade" [curto]="true" [comIcone]="true" />
          }
          <span class="mg-suporte-hub__status-titulo" [matTooltip]="linha.texto">{{ linha.texto }}</span>
          @if (linha.comIncidente) {
            <a class="mg-link" routerLink="/painel/suporte" fragment="status-do-sistema" (click)="fechar()">Ver status</a>
          }
        </p>
      }
    </div>

    <div class="mg-suporte-hub__corpo">
      <!--
        Achado da revisão (rodada 5, baixa, achado 9): a spec §6.1 pede a
        busca "em destaque", ocupando a largura cheia do painel — mas o campo
        herdava `.mg-barra-de-filtro__busca` (componentes.css: `max-width:
        360px`, pensado para a barra de filtro de uma LISTA, com o botão de
        filtro ao lado). O painel não tem botão nenhum ao lado da busca; o
        teto de 360px só sobrava espaço vazio. `.mg-suporte-hub__busca`
        (`inline-size: 100%`, `suporte.css`) já existia no arquivo, mas
        nenhum template a usava.
      -->
      <div class="mg-barra-de-filtro">
        <mat-form-field class="mg-suporte-hub__busca" subscriptSizing="dynamic">
          <mat-icon matPrefix svgIcon="search" class="mg-icone mg-icone--p" aria-hidden="true" />
          <input #campoBusca matInput placeholder="Buscar na ajuda" (input)="aoDigitar(campoBusca.value)" />
          @if (carregandoBase()) {
            <mat-spinner matSuffix diameter="20" aria-hidden="true" />
          }
        </mat-form-field>
      </div>

      @if (baseIndisponivel()) {
        <app-support-empty-state variante="erro" [compacto]="true" mensagemDoHospedeiro="A ajuda não carregou agora.">
          <button type="button" matButton="text" (click)="recarregarBase()">Tentar novamente</button>
        </app-support-empty-state>
      } @else if (carregandoBase()) {
        <p class="mg-suporte-hub__carregando">Carregando artigos.</p>
      } @else {
        <div>
          <p class="mg-suporte-painel__subtitulo">{{ termoBuscado() ? 'Resultados' : hub.artigoAlvo() ? 'Artigo selecionado' : 'Nesta tela' }}</p>
          @if (artigosExibidos().length === 0) {
            @if (termoBuscado()) {
              <app-support-empty-state variante="artigos-sem-resultado" [termo]="termoBuscado()" [compacto]="true" />
            } @else {
              <app-support-empty-state variante="artigos-da-tela-vazio" [compacto]="true" />
            }
          } @else {
            <mat-accordion [multi]="false">
              @for (artigo of artigosExibidos(); track artigo.slug; let primeiro = $first) {
                <mat-expansion-panel [expanded]="primeiro && !termoBuscado()" (opened)="artigoExpandido(artigo)">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <mat-icon svgIcon="menu_book" class="mg-icone mg-icone--p" aria-hidden="true" />
                      <span class="mg-suporte-hub__artigo-titulo" [title]="artigo.title">{{ artigo.title }}</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <!-- Achado A3 (revisão Astra, 31/10/2026): corpo e figuras só existem com o painel aberto. -->
                  <ng-template matExpansionPanelContent>
                  @if (artigo.availability; as disponibilidade) {
                    <dl class="grid gap-3 mb-4 text-sm" aria-label="Disponibilidade do artigo">
                      <div>
                        <dt class="font-semibold">Disponível em</dt>
                        <dd>{{ disponibilidade.planRequirement }}</dd>
                      </div>
                      @if (disponibilidade.permissionKeys.length > 0) {
                        <div>
                          <dt class="font-semibold">Permissões usadas neste guia</dt>
                          <dd>
                            <ul>
                              @for (rotulo of rotulosDePermissao(disponibilidade.permissionKeys); track rotulo) {
                                <li>{{ rotulo }}</li>
                              }
                            </ul>
                          </dd>
                        </div>
                      }
                      @if (disponibilidade.configurationRequirements.length > 0) {
                        <div>
                          <dt class="font-semibold">Antes de usar</dt>
                          <dd>
                            <ul>
                              @for (requisito of disponibilidade.configurationRequirements; track $index) {
                                <li>{{ requisito }}</li>
                              }
                            </ul>
                          </dd>
                        </div>
                      }
                    </dl>
                  }
                  <!--
                    Achado A6 (revisão Astra, 31/10/2026): "Verificado em" é a última revisão integral; em
                    changed-content, verifiedAt só data a alteração conferida depois dela. O papel interno de
                    revisão não aparece, como no site (A10).
                  -->
                  @let parcial = artigo.verificationScope === 'changed-content';
                  @let revisaoIntegral = parcial ? artigo.fullyVerifiedAt : artigo.verifiedAt;
                  @if (revisaoIntegral) {
                    <p class="text-sm">Verificado em <time [attr.datetime]="revisaoIntegral">{{ revisaoIntegral | date:'dd/MM/yyyy':'UTC' }}</time></p>
                  }
                  @if (parcial && artigo.verifiedAt && artigo.verifiedAt !== revisaoIntegral) {
                    <p class="text-sm">Alterações conferidas em <time [attr.datetime]="artigo.verifiedAt">{{ artigo.verifiedAt | date:'dd/MM/yyyy':'UTC' }}</time></p>
                  }
                  @if (artigo.video) {
                    <p class="text-sm">
                      <a class="mg-link" [href]="artigo.url + '#video'" target="_blank" rel="noopener noreferrer">
                        <mat-icon svgIcon="movie" class="mg-icone mg-icone--p" aria-hidden="true" />
                        Ver vídeo e descrição
                      </a>
                    </p>
                  }
                  <app-help-content [blocks]="artigo.content" [article]="artigo" [officialSource]="artigo.officialSource" (chamadoAberto)="aoAbrirChamado()" />
                  @if (resolvidos().has(artigo.slug)) {
                    <p class="mg-suporte-hub__obrigado" role="status">Obrigado. Retorno registrado.</p>
                  } @else {
                    <p>Este artigo ajudou?</p>
                    <div class="mg-suporte-hub__artigo-rodape">
                      <kt-button appearance="tonal" type="button" [loading]="votosPendentes().has(artigo.slug)" (handle)="marcarResolvido(artigo)">Sim</kt-button>
                      <button type="button" matButton="text" [disabled]="votosPendentes().has(artigo.slug)" (click)="abrirNegativo(artigo)">Não</button>
                    </div>
                    @if (votosPendentes().has(artigo.slug)) {
                      <p class="text-sm" role="status">Enviando retorno…</p>
                    }
                    @if (votosComFalha().has(artigo.slug)) {
                      <p class="mg-suporte-erro" role="alert">Não foi possível registrar seu retorno. Verifique a conexão e envie de novo.</p>
                    }
                    @if (retornoNegativo() === artigo.slug) {
                      <div class="grid gap-3">
                        <label [for]="'motivo-' + artigo.slug">Motivo (opcional)</label>
                        <select #motivo [id]="'motivo-' + artigo.slug" aria-label="Motivo opcional">
                          <option value="">Prefiro não informar</option>
                          @for (item of motivos; track item.valor) {
                            <option [value]="item.valor" [selected]="item.valor === motivoInicial()">{{ item.texto }}</option>
                          }
                        </select>
                        <mat-form-field>
                          <mat-label>Conte mais (opcional)</mat-label>
                          <textarea #detalhe matInput maxlength="500" placeholder="Descreva a dúvida sem dados pessoais"></textarea>
                        </mat-form-field>
                        <button type="button" matButton="text" [disabled]="votosPendentes().has(artigo.slug)" (click)="marcarNaoResolvido(artigo, motivo.value, detalhe.value)">Enviar retorno</button>
                      </div>
                    }
                  }
                  <!-- KB-REV-02: relatar erro fica disponível antes e depois do voto. -->
                  <p class="text-sm">
                    <button type="button" class="mg-link" (click)="reportarErro(artigo)">Reportar um erro nesta página</button>
                  </p>
                  @if (relatosRegistrados().has(artigo.slug)) {
                    <p class="mg-suporte-hub__obrigado" role="status">Obrigado. Relato registrado.</p>
                  }
                  @if (relatoAberto() === artigo.slug) {
                    <div class="grid gap-3">
                      <p>Motivo: {{ erroNaPagina }}</p>
                      <mat-form-field>
                        <mat-label>O que está errado? (opcional)</mat-label>
                        <textarea #relato matInput [id]="'relato-' + artigo.slug" maxlength="500" placeholder="Descreva o erro sem dados pessoais"></textarea>
                      </mat-form-field>
                      <button type="button" matButton="text" [disabled]="relatosPendentes().has(artigo.slug)" (click)="enviarRelato(artigo, relato.value)">Enviar relato</button>
                      @if (relatosPendentes().has(artigo.slug)) {
                        <p class="text-sm" role="status">Enviando relato…</p>
                      }
                      @if (relatosComFalha().has(artigo.slug)) {
                        <p class="mg-suporte-erro" role="alert">Não foi possível registrar seu relato. Verifique a conexão e envie de novo.</p>
                      }
                    </div>
                  }
                  <!-- Achado A2 (revisão Astra): a página completa continua acessível antes e depois do voto. -->
                  <p class="text-sm">
                    <a class="mg-link" [href]="artigo.url" target="_blank" rel="noopener noreferrer">
                      <mat-icon svgIcon="open_in_new" class="mg-icone mg-icone--p" aria-hidden="true" />
                      Abrir no site
                    </a>
                  </p>
                  </ng-template>
                </mat-expansion-panel>
              }
            </mat-accordion>
          }
        </div>
      }
    </div>

    <!--
      Achado da revisão (rodada 5, baixa, resíduo do achado 7): a pílula
      cortava com reticências, mas o rótulo ("Meus chamados"/"Novidades") e
      a pílula disputavam a MESMA célula — os dois têm `flex: 1 1 auto`, e o
      rótulo saía cortado sem dica nenhuma. A pílula agora mostra sempre o
      NÚMERO (`flex: none`, `suporte.css`); o rótulo fica com o espaço
      inteiro.

      Achado da revisão (rodada 6, baixa, client_codigo): a correção acima
      escondeu o complemento ("com resposta nova"/"nova"/"novas") em TODA
      largura, mas o painel de 440px do desktop já cabia a pílula inteira —
      o próprio comentário removido dizia isso. O complemento volta como
      `span` PRÓPRIO dentro do `aria-hidden`, visível por padrão e escondido
      só abaixo de 599px (suporte.css) — o `.sr-only` e o `matTooltip`
      continuam cobrindo o celular.
    -->
    <div class="mg-suporte-hub__rodape">
      <a class="mg-suporte-atalho" [routerLink]="['/painel/suporte/novo']" [queryParams]="{ de: rotaAtual() }" (click)="aoAbrirChamado()">
        <mat-icon svgIcon="add" class="mg-icone" aria-hidden="true" />
        <span>Abrir chamado sobre esta tela</span>
      </a>
      <a class="mg-suporte-atalho" routerLink="/painel/suporte" (click)="fechar()">
        <mat-icon svgIcon="support_agent" class="mg-icone" aria-hidden="true" />
        <span>Meus chamados</span>
        @if (hub.chamadosNaoLidos() > 0) {
          <span class="mg-suporte-contagem" [matTooltip]="hub.chamadosNaoLidos() + ' com resposta nova'">
            <span class="sr-only">{{ hub.chamadosNaoLidos() }} com resposta nova</span>
            <span aria-hidden="true">{{ hub.chamadosNaoLidos() }}<span class="mg-suporte-contagem__complemento"> com resposta nova</span></span>
          </span>
        }
      </a>
      <a class="mg-suporte-atalho" routerLink="/painel/suporte/novidades" (click)="fechar()">
        <mat-icon svgIcon="campaign" class="mg-icone" aria-hidden="true" />
        <span>Novidades</span>
        @if (hub.novidadesNaoVistas() > 0) {
          <span class="mg-suporte-contagem" [matTooltip]="hub.novidadesNaoVistas() + ' ' + (hub.novidadesNaoVistas() === 1 ? 'nova' : 'novas')">
            <span class="sr-only">{{ hub.novidadesNaoVistas() }} {{ hub.novidadesNaoVistas() === 1 ? 'nova' : 'novas' }}</span>
            <span aria-hidden="true">{{ hub.novidadesNaoVistas() }}<span class="mg-suporte-contagem__complemento"> {{ hub.novidadesNaoVistas() === 1 ? 'nova' : 'novas' }}</span></span>
          </span>
        }
      </a>
      <button type="button" class="mg-suporte-atalho" [disabled]="!tutorial.temTourNaRota()" (click)="verTour()">
        <mat-icon svgIcon="school" class="mg-icone" aria-hidden="true" />
        <span>Ver tour desta tela</span>
        @if (!tutorial.temTourNaRota()) {
          <span class="mg-suporte-hub__sem-tour">Esta tela ainda não tem tour.</span>
        }
      </button>
    </div>
  </aside>
}
